import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchCustomTheme } from 'redux/themes/actions';

import ColorPicker from 'components/dashboard/appearance-content/ColorPicker';

import './SocialIconsColor.css';

class SocialIconsColor extends Component {
  static propTypes = {
    patchCustomTheme: PropTypes.func.isRequired,
    setCustomMode: PropTypes.func.isRequired,
    me: PropTypes.object,
  }

  static defaultProps = {
    me: null,
  }

  state = {
    currentFontColor: null,
  };

  componentDidMount() {
    const { me } = this.props;
    if (me && me.custom_theme) {
      this.setState({
        currentFontColor: me.custom_theme.social_icon_color,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.me.custom_theme.social_icon_color !==
        this.props.me.custom_theme.social_icon_color &&
      this.state.currentFontColor !==
        this.props.me.custom_theme.social_icon_color
    ) {
      this.setState({ currentFontColor: this.props.me.custom_theme.social_icon_color });
    }
  }

  onFontColorChange = color => {
    const { me, setCustomMode, patchCustomTheme } = this.props;
    if (me.theme) { setCustomMode(); }
    const customThemeId = me && me.custom_theme && me.custom_theme.id;
    const form = new FormData();
    form.append('social_icon_color', color.hex);
    patchCustomTheme(customThemeId, form);
    this.setState({ currentFontColor: color.hex });
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div className="social-icon-color-selector__component">
            <div className="label">{t("Social Icons Color")}</div>
            <div className="picker-block">
              <ColorPicker
                key="social-icons_color_picker_key"
                pickerId="social-icons_color_picker_id"
                color={this.state.currentFontColor || '#bebebe'}
                onChangeComplete={this.onFontColorChange}
                disableAlpha
              />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCustomTheme,
  },
)(SocialIconsColor);
